import React, { ReactElement } from 'react';
import { HeroV2 } from '../../../components/Hero/HeroV2';
import { PageProperties } from '../../../types';

interface VerticalHeroProps {
  imageSrc: string;
  pageProperties: PageProperties;
}

export function VerticalHeroV2({
  imageSrc,
  pageProperties,
}: VerticalHeroProps): ReactElement {
  const { descriptorVariable, pageContent } = pageProperties;
  const {
    breadcrumbs,
    seoVertical,
    herosComponentData,
    eventTypes,
  } = pageContent;
  const { ingress, mainHeader } = herosComponentData.text;

  return (
    <HeroV2
      breadcrumbs={breadcrumbs}
      title={mainHeader}
      subtitle={ingress}
      imageSrc={imageSrc}
      vertical={seoVertical}
      eventTypes={eventTypes?.filter(eventType => eventType.isHerosEventType)}
      descriptorVariable={descriptorVariable}
    />
  );
}
